import React, {useEffect, useState} from 'react'
import {useNavbar} from "../states/common/client";
import {
    Box,
    Checkbox,
    Grid,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText
} from "@mui/material";
import {AlfyButton} from "../components/AlfyButton";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {useNavigate, useSearchParams} from "react-router-dom";
import {alfyToast} from "../utils/Utils";
import {kakaoLogin, me} from "../api/AlfyApiClient";

export const SignupPage = () => {
    // states
    const [checked, setChecked] = useState<number[]>([])

    // hooks
    const { reset, setNavbarBackButton, setNavbarTitle } = useNavbar()
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()

    const code = searchParams.get('code')
    const redirectUrl = searchParams.get('redirectUrl')

    useEffect(() => {
        reset()
        setNavbarBackButton(false)
        setNavbarTitle('회원가입')
    }, []);

    const handleToggle = (value: number) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    };

    const handleSignup = async () => {
        if (!checked.includes(0) || !checked.includes(1)) {
            alfyToast('이용약관과 개인정보 처리방침에 동의해주세요.')
        }
        if (!code) {
            alfyToast('잘못된 접근입니다.')
            return
        }

        const authTokens = await kakaoLogin(code);
        if (authTokens === null) {
            console.error("failed to signup with kakao");
            return
        }

        const userMe = await me();

        navigate(redirectUrl ?? '/default');
    }

    return (
        <div className={'fullscreen'}>
            <Grid height={'100%'} direction={'column'} justifyContent={'space-between'} container>
                <Grid item
                      flex={1}
                >
                    <List>
                        <ListItem key={0} secondaryAction={
                            <IconButton edge={'end'} onClick={() => { navigate('/policy/terms-of-service') }}>
                                <ChevronRightIcon />
                            </IconButton>
                        }>
                            <ListItemButton onClick={handleToggle(0)}>
                                <ListItemIcon>
                                    <Checkbox
                                        edge="start"
                                        checked={checked.includes(0)}
                                        tabIndex={-1}
                                        disableRipple
                                        inputProps={{ 'aria-labelledby': 'termsCheck' }}
                                    />
                                </ListItemIcon>
                                <ListItemText id={'termsCheck'} primary={`이용약관 동의`} />
                            </ListItemButton>
                        </ListItem>
                        <ListItem key={1} secondaryAction={
                            <IconButton edge={'end'} onClick={() => { navigate('/policy/privacy') }}>
                                <ChevronRightIcon />
                            </IconButton>
                        }>
                            <ListItemButton onClick={handleToggle(1)}>
                                <ListItemIcon>
                                    <Checkbox
                                        edge="start"
                                        checked={checked.includes(1)}
                                        tabIndex={-1}
                                        disableRipple
                                        inputProps={{ 'aria-labelledby': 'privacyCheck' }}
                                    />
                                </ListItemIcon>
                                <ListItemText id={'privacyCheck'} primary={`개인정보 처리방침 동의`} />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Grid>
                <Grid item>
                    <AlfyButton text={'가입하기'} onClick={handleSignup} />
                </Grid>
                <Grid item>
                    <Box height={'20px'}/>
                </Grid>
            </Grid>
        </div>
    );
}